import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import MyModal from 'components/modals/modal';
import Button from '@mui/material/Button';
import SendingEmailRecipient from './sending-email-recipient';

export default function SendingEmailsModal({
  open,
  setOpen,
  emailRequests,
  setOpenParentModal,
  setOpenBackfill,
  showInventory,
  selectedSender,
  selectedSignature,
}) {
  const [emailSentInfo, setEmailSentInfo] = useState(0);
  useEffect(() => {
    if (!open) {
      setEmailSentInfo(0);
    }
    return () => {
      // You can perform cleanup here if needed
      setEmailSentInfo(0);
    };
  }, [open]);
  var emailsSentText = (
    <Typography
      sx={{
        width: '100%',
        height: '40px',
        backgroundColor: '#E0FFE2',
        textAlign: 'center',
        fontSize: '18px',
        color: '#008800',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      Emails Sent: {emailSentInfo}
    </Typography>
  );

  const close = (
    <Button
      variant='outlined'
      color='secondary'
      onClick={() => {
        setOpen(false);
        setOpenParentModal(false);
        setOpenBackfill(false);
      }}
    >
      Close
    </Button>
  );

  return (
    <MyModal
      open={open}
      setOpen={(bool) => {
        setEmailSentInfo(0);
        setOpen(bool);
      }}
      size='large'
      title='Sending Emails...'
      sx={{ width: '780px', height: '50vh' }}
      actions={[emailsSentText, close]}
    >
      <Stack spacing={3}>
        <Stack spacing={1.5}>
          {emailRequests.map((request, i) => (
            <Stack key={i}>
              <SendingEmailRecipient
                request={request}
                setEmailSentInfo={setEmailSentInfo}
                showInventory={showInventory}
                selectedSender={selectedSender}
                selectedSignature={selectedSignature}
              />
            </Stack>
          ))}
        </Stack>
      </Stack>
    </MyModal>
  );
}

SendingEmailsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  openParentModal: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  setOpenParentModal: PropTypes.func.isRequired,
  emailRequests: PropTypes.array.isRequired,
  setOpenBackfill: PropTypes.func,
  showInventory: PropTypes.bool,
  selectedSender: PropTypes.string,
  selectedSignature: PropTypes.string,
};
SendingEmailsModal.defaultProps = {
  selectedSender: '',
  selectedSignature: '',
  setOpenParentModal: () => {},
  setOpenBackfill: () => {},
};
